import { render } from "./roleadmin.vue?vue&type=template&id=216c16ee&scoped=true"
import script from "./roleadmin.vue?vue&type=script&lang=js"
export * from "./roleadmin.vue?vue&type=script&lang=js"

import "./roleadmin.vue?vue&type=style&index=0&id=216c16ee&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216c16ee"]])

export default __exports__